var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 40,
    viewBox: "0 0 32 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9996 21.8C18.9819 21.8 21.3996 19.3823 21.3996 16.4C21.3996 13.4177 18.9819 11 15.9996 11C13.0173 11 10.5996 13.4177 10.5996 16.4C10.5996 19.3823 13.0173 21.8 15.9996 21.8Z",
    stroke: "#FCAF33",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9996 38C23.1996 30.8 30.3996 24.3529 30.3996 16.4C30.3996 8.4471 23.9525 2 15.9996 2C8.04671 2 1.59961 8.4471 1.59961 16.4C1.59961 24.3529 8.79961 30.8 15.9996 38Z",
    stroke: "#FCAF33",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.618dcca34f06a617f55f3754c6bfcbff.svg";
export { ForwardRef as ReactComponent };